import { ExternalUrlItem } from 'app/area/external-urls-administration/form/types-store';
import { ComplexValue } from 'app/types-shared';

export const getDisabledOptions = (originalExternalUrlItem: ExternalUrlItem, excludableFieldsOptions: ComplexValue<number>[]) => {
  return (originalExternalUrlItem && originalExternalUrlItem.excludeFields && excludableFieldsOptions)
    ?
    originalExternalUrlItem.excludeFields.filter(excludeField =>
      excludableFieldsOptions.every(option => option.value !== excludeField.value)
    )
    : [];
};
